<script setup lang="ts">
import {X} from "utruckin-icons"
import {onMounted, ref, watch} from 'vue'
import {useSearchStore} from "@/features/search/search.store";

const searchStore = useSearchStore()

const inputRef = ref<HTMLInputElement | null>(null)
const loading = ref<boolean>(false);
let timeout: ReturnType<typeof setTimeout>
let controller: AbortController | null = null

const focusInput = () => {
  inputRef.value?.focus()
}

const clearInput = () => {
  searchStore.smartSearchFilter.q = ''
}

const getSmartSearch = async () => {
  if (controller) controller.abort()
  controller = new AbortController()

  try {
    await searchStore.smartSearch(loading, controller.signal)
  } catch (error: any) {
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      return
    }
  }
}

onMounted(() => {
  getSmartSearch()
})

watch(
    () => JSON.stringify(searchStore.smartSearchFilter),
    () => {
      if (!searchStore.smartSearchFilter.q.trim()) {
        controller?.abort()
        return
      }
      clearTimeout(timeout)

      timeout = setTimeout(() => {
        getSmartSearch()
      }, 500)
    }
)
</script>

<template>
  <div class="w-ui-search" @click="focusInput">
    <input ref="inputRef" v-model="searchStore.smartSearchFilter.q" type="text" placeholder="Search for all..."/>
    <div class="action" @click="clearInput">
      <X :size="16"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.w-ui-search {
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-bg-secondary);
  border: 1px solid var(--color-border);
  border-radius: 14px;
  cursor: pointer;

  input {
    border: none;
    outline: none;
    color: var(--color-label);
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    background: transparent;

    &:focus {
      outline: none;
    }
  }

  .action {
    width: 32px;
    height: 32px;
    background: var(--color-background);
    border: 1px solid var(--color-border);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-label);

    &:hover {
      background: var(--color-bg-secondary);
    }
  }
}
</style>